import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { Platform } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';
//import { Zoom } from '@ionic-native/zoom/ngx';
import { ServicesProvider } from 'src/providers/services';
import { AddCall } from 'src/providers/addvCall';
import { TranslateService } from '@ngx-translate/core';
//import { Payment } from 'src/providers/payment';
//import { FCM } from '@ionic-native/fcm/ngx';
@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent {
  SDK_KEY: string = "y3R0NYoqnPRE1nQSdq0RZq2RrgZpkweJGvay";
  SDK_SECRET: string = "E5C7kUB4HUnYJicYnPItg6gqYYKe5Zi6GeJT";
  //SDK_KEY: string = "HFMWPEwFuWtS2dVA1rDJbymLSY7qr2y5G5oZ";
  //SDK_SECRET: string = "wi3uxVhW5qy3hfc1coq6j6BtXUlTSVKifmVQ";


  formjs: any;
  selectedLanguage: any;
  isShowLocalPushNotification: Boolean = false;
  localPushNotificationTitle = '';
  localPushNotificationContent = '';
  localPushNotificationLang = '';

  constructor(
    private router: Router,
    private platform: Platform,
    private splashScreen: SplashScreen,
    private statusBar: StatusBar,
    // private zoomService: Zoom,
    public services: ServicesProvider,
    public addCall: AddCall,
    private _translate: TranslateService,
    //private fcm: FCM,
    //private payment : Payment
  ) {
    this.importCall();
    this.initializeApp();
    //this.Router.navigate(['/splash-screen']);
    //this.Router.navigate(['/tabs/home']);
    //this.Router.navigate(['/login']);
  }



  receiveNotification(data: any){
    this.localPushNotificationTitle = data.title;
    this.localPushNotificationContent = data.body;
    this.localPushNotificationLang = data.lang;
    this.isShowLocalPushNotification = true;
    setTimeout(() => {
      this.isShowLocalPushNotification = false;
    }, 6000);
  }


  initializeApp() {

    localStorage.setItem("selectedLanguage", "en");
    // this.getAppoinmentCount();

    this.addCall.checkTranslate();


    // this.setAppTranslation();
    this._translate.addLangs(["en", "ea"]);
    this._translate.setDefaultLang('en');
    this._translate.use('en');

    if (!window.localStorage['isAddOpened']) {
      window.localStorage['isAddOpened'] = 0;

    }
    console.log("Is Add Openned - ", window.localStorage['isAddOpened']);
    if (!window.localStorage['DocADD']) {
      window.localStorage['DocADD'] = 0;
    }
    if (!window.localStorage['LabADD']) {
      window.localStorage['LabADD'] = 0;
    }
    if (!window.localStorage['HomeADD']) {
      window.localStorage['HomeADD'] = 0;
    }
    if (!window.localStorage['PresADD']) {
      window.localStorage['PresADD'] = 0;
    }
    if (!window.localStorage['RepADD']) {
      window.localStorage['RepADD'] = 0;
    }
    if (!window.localStorage['BookADD']) {
      window.localStorage['BookADD'] = 0;
    }
    if (!window.localStorage['NurseADD']) {
      window.localStorage['NurseADD'] = 0;
    }
    if (!window.localStorage['DietADD']) {
      window.localStorage['DietADD'] = 0;
    }
    if (!window.localStorage['TrainCent']) {
      window.localStorage['TrainCent'] = 0;
    }
    if (!window.localStorage['Physio']) {
      window.localStorage['Physio'] = 0;
    }
    if (!window.localStorage['trainer']) {
      // window.localStorage['trainer'] = 0;
      localStorage.setItem("trainer", "0")
    }

    // localStorage.clear();

    // localStorage.setItem("patient_id", "0");
  
    this.platform.ready().then(() => {
      this.statusBar.backgroundColorByHexString('#510f30');
      // this.zoomService.initialize(this.SDK_KEY, this.SDK_SECRET)
      //   .then((success: any) => console.log(success))
      //   .catch((error: any) => console.log(error));
      this.platform.backButton.subscribeWithPriority(9999, () => {
        document.addEventListener('backbutton', function (event) {
          event.preventDefault();
          event.stopPropagation();
          console.log('hello');
        }, false);
      });
      //this.statusBar.styleDefault();
    });
  }

  ngOnInit() {
    // let uID = localStorage.getItem("patient_id");
    // if(uID==null || uID==undefined || uID=="" || uID=="null" || uID=="undefined") {
    //   this.Router.navigate(['/login']);
    // } else {
    //   this.Router.navigate(['/tabs/home']);
    // }
  }

  getAppoinmentCount() {
    let apiData = JSON.stringify({
      "currentDate": new Date().toISOString().split("T")[0],
      "patientId": localStorage.getItem("patient_id"),
      "current_time": new Date().toTimeString().split(" ")[0]
    });
    this.services.postRequest("patientBookedAppointmentListCount", apiData).subscribe(res => {
      console.log(res);
      let storeNoOfApmnts = res.data.details[0].upCommingAppointmentCount;
      console.log("NoOfApmnts=>", storeNoOfApmnts);
      window.localStorage["storeNoOfApmnts"] = storeNoOfApmnts;
    });
  }

  async importCall() {
    this.formjs = await import('../providers/route.js');
    this.formjs.routerPush(this.router);
  }
}
